/*
 * @Author: LCJ
 * @Date: 2025-04-03 18:02:56
 * @LastEditTime: 2025-12-25 09:06:29
 * @LastEditors: LCJ
 * @Description: 
 * @FilePath: \schoolDistricts\src\main.js
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/element.js'
import store from './store'
import xybAgent from '@xybplugins/xyb-agent'
import axios from 'axios'
Vue.prototype.$axios = axios

Vue.config.productionTip = false

xybAgent.init('production')

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')